import React, { useMemo } from 'react'
import { IconButton, SwitchBase } from '@instacart/ids-customers'
import { EditIcon, TrashIcon } from '@instacart/ids-core'
import { type Datum } from './PublishDataGrid'
import PublishDataGridRow from './PublishDataGridRow'

interface PublishDataGridReadOnlyRowProps {
  datum: Datum
  onDelete: () => void
  onEdit: () => void
  disabled?: boolean
}

const PublishDataGridReadOnlyRow: React.FC<PublishDataGridReadOnlyRowProps> = ({
  datum,
  onDelete,
  onEdit,
  disabled,
}) => {
  const s = <SwitchBase checked={datum.required} disabled description="Required" />
  const actions = useMemo(
    () => [
      <IconButton
        icon={EditIcon}
        key="edit"
        onPress={onEdit}
        accessibleLabel="Edit"
        disabled={disabled}
      >
        Edit
      </IconButton>,
      <IconButton
        icon={TrashIcon}
        key="delete"
        onPress={onDelete}
        accessibleLabel="Delete"
        disabled={disabled}
      >
        Delete
      </IconButton>,
    ],
    [onDelete, onEdit, disabled]
  )

  return (
    <PublishDataGridRow
      attributeName={datum.attributeName}
      campField={datum.campField}
      required={s}
      actions={actions}
    />
  )
}

export default PublishDataGridReadOnlyRow
